'use strict';

import angular from 'angular';
import AddConfController from './addConf.controller';

export default angular.module('onyxReadingRoomApp.appstore.addconf', [])
  .controller('AppStoreAddConfController', AddConfController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/addConf/index.js